import { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Components
import Header from "./components/Header";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import ScrollButton from "./components/ScrollButton";

// Pages
import HomePage from "./pages/HomePage";
import SurahPage from "./pages/SurahPage";
import BookmarksPage from "./pages/BookmarksPage";
import FavoritesPage from "./pages/FavoritesPage";

// Hooks
import { useTheme } from "./hooks/useQuran";

function AppContent() {
  // Initialize theme
  useTheme();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="safe-left safe-right">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/surah/:surahNo" element={<SurahPage />} />
          <Route path="/bookmarks" element={<BookmarksPage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
        </Routes>
      </main>
      <ScrollButton />
      <Toaster position="bottom-center" className="safe-bottom" />
      <PWAInstallPrompt />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
